export default __webpack_public_path__ + "static/media/OmaduroChurchillOpen.3009edbb.jpg";